<template>
  <div>
    <click-to-edit
      v-if="value.scale_type === $cascadingConstants.scales.types.TYPE_QUANTITY"
      v-model="value[performanceValueName]"
      digits-only
      :disabled="disabled"
      placeholder=""
      @input="changedQuantity"
    ></click-to-edit>

    <click-to-edit
      v-if="value.scale_type === $cascadingConstants.scales.types.TYPE_QUALITY"
      v-model="value.scale[performanceValueName + '_scope_id']"
      type="select"
      :disabled="disabled"
      placeholder=""
      select-filterable
      :select-options="scopes"
      select-option-id="id"
      select-option-name="name"
      select-cast-value-to-int
      @input="changed"
    >
    </click-to-edit>
  </div>
</template>

<script>


import ClickToEdit from "@/components/ClickToEdit.vue";

export default {
  name: "CascadingScalePerformanceValuesInput",
  components: {ClickToEdit},
  props: {
    value: {type: Object, required: true}, // whole element
    performanceValueName: {type: String, required: true},
    disabled: {type: Boolean, default: false},
  },

  computed: {
    scopes() {
      if( this.value?.scale?.template_id ) {
        return this.value.scale?.template?.scopes || [];
      }
      return this.value?.scale?.scopes || [];
    },
  },
  data() {
    return {}
  },

  methods: {
    changedQuantity() {
      this.value.scale[this.performanceValueName] = this.value[this.performanceValueName];
      this.changed();
    },

    changed() {
      this.$emit('input', this.value);
      this.$emit('change', this.value);
    }
  },

}
</script>


<style scoped>

</style>